import { gql } from "@apollo/client";

export default gql`
  query getAssignedHospitalReports {
    getAssignedHospitalReports {
      id
      name
    }
  }
`;
